module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('section', {
    staticClass: "pass-view"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("本场活动需要密码访问")]), _vm._v(" "), _c('input', {
    staticClass: "text-input",
    attrs: {
      "id": "pass",
      "autofocus": "",
      "type": "text",
      "maxlength": "6",
      "placeholder": "请输入访问密码"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.enter
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-xiangyou1"
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c76ed6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PassView/PassView.vue
// module id = 492
// module chunks = 1